import { FC, ReactNode, useMemo } from "react";
import { Locale } from "lib/Intl";
import { Department } from "src/types/department";
import { PLPType } from "src/types/PLPType.d";
import { InstantSearchWrapper } from "./InstantSearchWrapper";
import { OptionsSortBy } from "./withAlgoliaState";
import useProductFiltersOptionOrder from "src/hooks/useProductFiltersOptionOrder";

export interface AlgoliaProductListProps {
  collectionId?: string;
  brandId?: string;
  brandName?: string;
  categorySlug?: string;
  genderId: string;
  locale: Locale;
  hideCategoryTree?: boolean;
  hidePromotions?: boolean;
  excludedFacetsList?: string[];
  plpType: PLPType;
  limit?: number;
  setLoading?: (value: boolean) => void;
  defaultSort?: OptionsSortBy;
  department?: Department;
  slug?: string;
  title?: ReactNode;
  hideBreadcrumbs?: boolean;
  dataLoading?: boolean;
  searchTerm?: string;
  noSearchResults?: ReactNode;
  brandSlug?: string;
}

export type CategoryTreeSlugOrder = Record<string, number>;

const AlgoliaProductList: FC<AlgoliaProductListProps> = ({
  collectionId,
  brandName,
  brandId,
  brandSlug,
  genderId,
  locale,
  hideCategoryTree = false,
  hidePromotions = false,
  excludedFacetsList = [],
  plpType,
  limit,
  categorySlug,
  setLoading,
  defaultSort,
  department,
  slug,
  title,
  hideBreadcrumbs = false,
  dataLoading,
  searchTerm,
  noSearchResults,
}) => {
  const { data } = useProductFiltersOptionOrder();
  const categoryTreeSortOrder = useMemo(
    () =>
      data?.productFiltersOptionOrder?.category.reduce((acc, curr) => {
        acc[curr.slug] = curr.order;
        return acc;
      }, {} as CategoryTreeSlugOrder),
    [data?.productFiltersOptionOrder]
  );

  return (
    <InstantSearchWrapper
      hidePromotions={hidePromotions}
      hideCategoryTree={hideCategoryTree}
      brandName={brandName}
      brandId={brandId}
      brandSlug={brandSlug}
      collectionId={collectionId}
      genderId={genderId}
      locale={locale}
      excludedFacetsList={excludedFacetsList}
      plpType={plpType}
      limit={limit}
      categorySlug={categorySlug}
      setLoading={setLoading}
      defaultSort={defaultSort}
      department={department}
      slug={slug}
      title={title}
      hideBreadcrumbs={hideBreadcrumbs}
      dataLoading={dataLoading}
      searchTerm={searchTerm}
      noSearchResults={noSearchResults}
      categoryTreeSortOrder={categoryTreeSortOrder}
    />
  );
};

export default AlgoliaProductList;
